<div class="common-layout {{ 'is-' + selectedHeaderColor }}"
    [ngClass]="{
        'is-folded': isFolded,
        'is-side-nav-dark' : isSideNavDark,
        'is-expand' : isExpand
    }"
>
    <app-header></app-header>
    <app-sidenav></app-sidenav>
    <div class="page-container">
        <div class="main-content">
            <div class="main-content-header" *ngIf="contentHeaderDisplay !== 'none'">
                <nz-breadcrumb nzSeparator=">">
                    <i class="m-r-5 text-gray" nz-icon nzType="home"></i>
                    <nz-breadcrumb-item *ngFor="let breadcrumb of breadcrumbs$ | async">
                        <span>
                            {{ breadcrumb.label }}
                        </span>
                    </nz-breadcrumb-item>
                </nz-breadcrumb>
            </div>
            <nz-page-header class="page-header" *ngIf="header"></nz-page-header>
            <router-outlet></router-outlet>
            <router-outlet name="popup"></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
</div>
